/**
 * MONSTER TOWN — VISIT YOUR BROTHER'S TOWN. VISIT CREW (src/visit/**).
 *
 * ONE install line in `main.ts`, in the crew band, and nothing else.
 *
 * The feature in one paragraph: both save slots live on the same iPad, so a kid
 * can walk into the other one and look around. Nothing over there can be moved,
 * deleted or broken — not because the buttons are hidden (they are, but that is
 * the smaller half) but because `src/core/save.ts` refuses to write a byte to
 * ANY slot while a visit is open, and there is no function anywhere in
 * `SaveManager` that takes a slot argument and writes it. You can leave a
 * present on their doorstep, which is the ONE cross-slot exchange, and it is
 * append-only into your OWN outbox — your brother's save is never written by
 * anybody but your brother. A picture of their town comes home in your album.
 *
 * Read `state.ts` before changing anything here.
 */

import type { GameContext } from '../app/context'
import { visit } from './state'
import { installVisitUi } from './ui'

export function installVisit(ctx: GameContext): void {
  visit.attach(ctx)
  installVisitUi(ctx)
}

export { visit } from './state'
